import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EntityValidation, ValidationRejection } from '../../models/entity-validation.model';
import { Document } from 'src/app/features/documents/models/document.models';
import { Router } from '@angular/router';
import { EntityService } from '../../services/entity.service';
import { EntityValidatorService } from '../../services/entity-validator.service';

@Component({
  selector: 'gio-entity-validation-view',
  templateUrl: './entity-validation-view.component.html',
  styleUrls: ['./entity-validation-view.component.scss']
})
export class EntityValidationViewComponent implements OnInit {

  validation: EntityValidation;
  documentsRejecteds = [];

  constructor(
    private modalRef: MatDialogRef<EntityValidationViewComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: { validation?: EntityValidation, validation_uid?: string },
    private router: Router,
    private sEntity: EntityService,
    private sValidation: EntityValidatorService
  ) { }

  ngOnInit() {
    if (this.data.validation) {
      this.validation = this.data.validation;
      this.start();
    } else if (this.data.validation_uid) {
      this.sValidation.getValidationByUID(this.data.validation_uid).subscribe(
        data => {
          this.validation = data;
          this.start();
        },
        () => {
          this.close();
        });
    }
  }

  start() {
    if (this.validation) {

      if (this.validation.rejections) {
        this.validation.rejections = this.validation.rejections.map(r => {
          if (r instanceof ValidationRejection) {
            return r;
          }
          return new ValidationRejection(r);
        });

        this.documentsRejecteds = this.validation.rejections.filter(v => v.type === 'D');
      }

      if (this.validation.documents) {
        this.validation.documents = this.validation.documents.map(d => {
          if (d instanceof Document) {
            return d;
          }
          return new Document(d);
        });
      }
    }
  }

  close() {
    this.modalRef.close();
  }

  rejectionClick(rejection: ValidationRejection) {

    if (rejection.type === 'D' && +this.validation.validated_id === +this.sEntity.context.id) {
      this.router.navigate(['home', this.sEntity.context.source_name, 'documents']);
      this.close();
    }


  }

}
